module.exports = __webpack_public_path__ + "img/power1.0b1ef433.png";